import _ from "lodash";
import React from "react";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
// import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";
import PlayerPickerButtons from "./PlayerPickerButtons";
import PlayerPickerDropdownFilter from "./PlayerPickerDropdownFilter";
import PlayerPickerSelect from "./PlayerPickerSelect";


class GenericPicker extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(value, label, pickerItems) {
				
		//if (event !== null) {
		//	value = event.value;
		//}

		if (this.props.onChange) {
			console.log("Updating value", _.isString(value), value);
			let pickerItem = _.find(pickerItems, { value: value });
			const { item } = this.props;
			let speakValue = false;
			if (item && !item.suppressAudioValue) {
				speakValue = true;
			}

			this.props.onChange(value, (pickerItem) ? pickerItem : undefined, speakValue);
		}
	}

	render() {

		const { item, pickerItemsDatasourceResource, type, disabled } = this.props;
		const { pickerItemsDatasource, pickerItems } = item;

		// console.log(item.value + " >>> VALUE");

		let options = [];

		let newPickerItems = pickerItems.slice(0);

		// Resolve the picker items if it is tied to data source
		let loading, loadingFailure;
		let resolved = false;
		if (pickerItemsDatasourceResource && !_.isEmpty(pickerItemsDatasourceResource)) {
			// console.log("Picker Item Data Source", pickerItemsDatasourceResource);
			const ds = pickerItemsDatasourceResource;
			if (ds.loading) {
				loading = <div style={{ margin: "15px" }}><FontAwesomeIcon
					icon='spinner'
					spin /> Loading data source...</div>;
			} else if (ds.loadingError) {
				loadingFailure = <div style={{ color: "red" }}>Failed to load data source, picker items not available.<div><b>Reason:</b><br />{ds.loadingError}</div></div>;
			} else if (ds.content) {
				const content = ds.content;
				const labelKeys = pickerItemsDatasource.labelKeys;
				const valueKey = pickerItemsDatasource.valueKeys[0];

				// Super hack
				if (_.indexOf(labelKeys, "employeeId") !== -1 || valueKey === "employeeId") {
					this.requiresSignaturePads = true;
				}

				newPickerItems = content ? content.map(entry => {

					const labelParts = labelKeys.map(labelKey => {
						return entry[labelKey];
					});

					return {
						label: labelParts.join(" "),
						value: entry[valueKey],
						searchKey: _.values(entry).join("-")
					};
				}) : [];
			}
		}

		let valueKey = "value";
		let labelKeys = ["label"];

		if (!resolved && item.hasOwnProperty("x_pickerItemsDatasource")) {
			const dsDefinition = item["x_pickerItemsDatasource"];
			valueKey = _.first(dsDefinition.valueKeys);
			labelKeys = dsDefinition.labelKeys;
		}

		_.each(newPickerItems, (pickerItem) => {
			if (pickerItem.properties && pickerItem.properties !== "") {
				let properties = pickerItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(pickerItem, propertiesObject);
			}

			const value = pickerItem[valueKey];
			let label = [];
			labelKeys.forEach(lk => {
				label.push(pickerItem[lk]);
			});

			options.push(_.assign({},pickerItem,{ value, label: label.join(" ") }));
		});

		console.log("The following ");
		let component = <div>Unknown Picker Component Type :(</div>;
		if (loading) {
			component = loading;
		} else if (loadingFailure) {
			component = loadingFailure;
		} else {
			switch (type) {
				case "PlayerPickerButtons": {
					component = <PlayerPickerButtons options={options} item={item} disabled={disabled} onChange={(value,label) => this.onChange(value,label, newPickerItems)}/>;
					break;
				}
				case "PlayerPickerDropdownFilter": {
					component = <PlayerPickerDropdownFilter options={options} disabled={disabled} item={item} onChange={(value,label) => this.onChange(value,label, newPickerItems)}/>;
					break;
				}
				case "PlayerPickerSelect": {
					component = <PlayerPickerSelect options={options} disabled={disabled} item={item} onChange={(value,label) => this.onChange(value,label, newPickerItems)}/>;
					break;
				}	
				default: {
					component = <div>Unknown Picker Component Type :(</div>;
				}	
			}
		}

		return component;
	}
}

export default GenericPicker;